import { Observable } from 'rxjs';
import { NotificationType } from '../enums/notification-type.enum';

export interface IAumicoCoreProvider {
    dispatchBlockingRequest(identifier: string): void;
    dispatchBlockingRequestEnd(identifier: string): void;
    dispatchAddNotification(
        titleLocalizationKey: string,
        descriptionLocalizationKey: string,
        type?: NotificationType,
        autoHideDelay?: number,
    ): void;
    getBlockingRequestIsRunning$(): Observable<boolean>;
}
